import { PlanShared } from 'src/app/presentation/general/shared/plan-shared';
import { RouteAnimationShared } from './../../../utils/route-animation-shared';
import { SnackBarService } from './../../../data/repository/utils-repository/snack-bar.service';
import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { GenerateShared } from '../../general/shared/generate-shared';
import { mainUrl } from 'src/app/global-variables';
import { GenerateDataService } from 'src/app/data/repository/generate-repository/generate-data.service';
import { GenerateService } from 'src/app/data/repository/generate-repository/generate.service';
import { Location } from '@angular/common';
import {
  DietsListCategory,
  DietsListDietType,
} from 'src/app/core/model/api-response/plans-response-model';
import { PlansService } from 'src/app/data/repository/plans-repository/plans.service';

@Component({
  selector: 'app-diet-type',
  templateUrl: './diet-type.component.html',
  styleUrls: ['./diet-type.component.scss'],
})
export class DietTypeComponent implements OnInit {
  @Input() isDetail = false;

  dietsListCategories: DietsListCategory[] = [];
  personalDiet: DietsListDietType;

  dataIsReady = false;

  constructor(
    public generateShared: GenerateShared,
    private router: Router,
    private generateDataService: GenerateDataService,
    private generateService: GenerateService,
    private snackBarService: SnackBarService,
    private location: Location,
    private planShared: PlanShared,
    private plansService: PlansService,
    private routeAnimationShared: RouteAnimationShared
  ) {}

  ngOnInit() {
    if (this.isDetail) {
      this.getDietsList();
    }
  }

  async getDietsList() {
    const response = await this.plansService.getDietsList();
    if (response.isSuccess()) {
      this.dietsListCategories = response.getData().getDietsListCategories();
      this.dietsListCategories = this.dietsListCategories.filter((obj) => {
        if (obj.name === 'رژیم شخصی‌سازی شده') {
          this.personalDiet = obj.dietTypes[0];
        }
        return obj.name !== 'رژیم شخصی‌سازی شده';
      });
      this.dataIsReady = true;
    } else {
      this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
    }
  }

  personalSelected() {
    this.generateShared.selectedDietTypeTemp = this.personalDiet;
    this.showPreview();
  }

  dietTypeSelected(dietType: DietsListDietType) {
    this.generateShared.selectedDietTypeTemp = dietType;
    this.showPreview();
  }

  showPreview() {
    document.getElementById('page1').style.right = '-100%';
    document.getElementById('page2').style.right = '0';
  }

  back() {
    document.getElementById('page1').style.right = '0';
    document.getElementById('page2').style.right = '100%';
  }

  cancel() {
    this.generateShared.selectedDietType = null;
    this.generateShared.goal = null;
    this.generateShared.isCanceling = false;
    this.routeAnimationShared.showRouteAnimation();
    if (
      this.generateShared.previousUrl === 'planOverview' ||
      this.generateShared.previousUrl === 'mealDetail'
    ) {
      this.generateShared.previousUrl = '';
      this.location.back();
    } else {
      this.planShared.isDeeplink = false;
      this.router.navigate([mainUrl]);
    }
  }

  start() {
    if (this.isDetail) {
      this.generateShared.selectedDietType =
        this.generateShared.selectedDietTypeTemp;
      if (
        this.generateShared.selectedDietTypeTemp.isPersonal ||
        this.generateShared.selectedDietType.fasting
      ) {
        this.generateShared.goal = 'weightLoss';
      } else {
        this.generateShared.goal = null;
      }
      this.generateShared.closeOverviewDetailAndChangeDifficulty();
    } else {
      if (this.generateShared.selectedDietType.id === '0') {
        this.dataIsReady = false;
        this.generateShared.selectedDietType = null;
        this.generateService.goToDietPersonalType();
      } else {
        this.generateService.goToGenerate();
      }
    }
  }
}
